<div
    class="dsh-actions"
    fxFlex="grow"
    fxLayout.gt-sm="row"
    fxLayout="column"
    fxLayoutAlign="space-between"
    fxLayoutGap="24px"
>
    <ng-content></ng-content>
</div>
